import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { cloneElement } from 'react';
import { css } from '@emotion/react';
import { visuallyHidden } from '@guardian/src-foundations/accessibility';
export const buttonContents = ({ hideLabel, iconSvg, children, }) => {
    const contents = [children];
    if (iconSvg) {
        if (!hideLabel) {
            contents.push(_jsx("div", { className: "src-button-space" }, "space"));
        }
        contents.push(cloneElement(iconSvg, { key: 'svg' }));
    }
    if (hideLabel) {
        return (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ css: css `
						${visuallyHidden};
					` }, { children: children }), void 0), contents[1]] }, void 0));
    }
    else {
        return contents;
    }
};
//# sourceMappingURL=shared.js.map
